import { z } from 'zod'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }

  return { message: ctx.defaultError }
})

export const templateSchema = z.object({
  unidade: z
    .object({
      id: z.string().optional()
    })
    .optional(),
  conteudo: z.string().min(1, 'O conteúdo não pode ser vazio'),
  nome: z.string().min(1, 'O nome deve ter pelo menos 1 caracteres'),
  id: z.number().optional(),
  inclusao: z.string().optional()
})

export type TemplateFormData = z.infer<typeof templateSchema>
